import ProgressBar from "./ProgressBar";
import './ProgressBar.scss';

export default ProgressBar